// extracted by mini-css-extract-plugin
export default {"minMaxLabel":"slider_minMaxLabel__2RKRu"};